import { TestServiceService } from './../../../../core/services/testService/test-service.service';
import { Component, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  addQuestion,
  confirmDelete,
  existedQuestion,
  existedResponse,
  failedDelete,
  serverError,
  successCreateTestEsn,
  successDeletequestion,
  updatedQuestion,
} from './../../../../core/models/messages';
import { IQuestion } from './../../../../core/models/questionTestEsn';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-test-offer',
  templateUrl: './add-test-offer.component.html',
  styleUrls: ['./add-test-offer.component.css'],
})
export class AddTestOfferComponent {
  parentItem = 'Il n\'y a aucune question pour le moment. ';
  /* string */
  mode: string = 'create_question';
  categoryName!: string;
  CheckedMission: any;
  jobId!: number;
  state :number =2;
  value:any;
  action: string =''
  /* form group */
  questionForm: FormGroup = this.createForm();
  isDuplicateResponseErrorShown: boolean = false;
  pagination : boolean =false;
  selectedIndex: number | null | undefined = null;
  /* arrays */
  idResponse: number[] = [];
 changed_response: any[] = [];
  /* modal */
  modalRef?: BsModalRef;
  testType: string | null | undefined
  creationTestPayload: {job_offer_id : number | null, questions : any[]} = {job_offer_id: null, questions : []}

  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private testService: TestServiceService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router
  ) {

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.testType = navigation.extras.state['testType'];
    } 
    this.activatedRoute.queryParams.subscribe(params => {
      this.jobId = params['jobId'];
      this.action = params['action'];
      this.value = params['state'];
    });
    this.getQuestions()
  }

  ngOnInit() {
    if(!this.testType){
      this.router.navigateByUrl('/offres-emploi/liste-offres-emploi')
    }
    this.creationTestPayload.job_offer_id = this.jobId
  }

  navigateToBareme(){
    this.router.navigate([
      '/offres-emploi/add-bareme',
      { jobId: this.jobId , state:0},
    ]);
  }

   openDeleteQuestionAlert(data: any) {
    Swal.fire({
      title: `${confirmDelete} ce question?`,
      icon: 'question',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteQuestion(data.pUid);
      }
    });
  }

  deleteQuestion(pUid: any) {
    const index = this.creationTestPayload?.questions?.findIndex(item => item.pUid === pUid);
    if (index !== -1) {
      this.creationTestPayload?.questions?.splice(index, 1);
    }
  }

  getQuestions() {    
    if(this.action === 'update'){
      this.spinner.show();
      this.testService
        .getTestQuestions(this.jobId)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            res.data?.questions?.map((element : IQuestion) => {
              this.creationTestPayload.questions.push({
                id: element.question.id,
                question_FR: element.question.question_FR,
                response_state: element.question.response_state,
                time: element.question.time?.toString(),
                response_question : element.question.response_state == 1? element.question.response_question  : [],
                pUid: crypto.randomUUID() // adding a private uuid (id = null for new items)
              })
            })
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
          },
        });
    }
  }
 
  /* create add candidat form */
  createForm(data?: any) {
    return this.formBuilder.group({
      idQuestion: data?.id ? data?.id : null,
      job_offer_id: [this.jobId],
      response_state: [data ? data.response_state : '2'],
      question_FR: [
        data ? data.question_FR : '',
        [
          Validators.required,
          // this.notOnlySpacesValidator(),
          // Validators.pattern('^[a-zA-Z][a-zA-Z0-9]*$'),
          // Validators.pattern('^[a-zA-Z0-9\s\r\n]*$')
          // Validators.pattern('^(?!\\s*$).+') // Cette expression régulière vérifie qu'il y a au moins un caractère non-espace dans la chaîne
          // Validators.pattern('^(?!\\s*$)(?!.*\\d)[a-zA-Z\\s!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]*$')
          // Validators.pattern('^(?!\\s*$)[a-zA-Z0-9\\s!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]*$')
          Validators.pattern(
            '^(?!\\s*$)[a-zA-Z0-9éèàùçâêîôûäëïöüÿœæ²\\s!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]*$'
          ),
        ],
      ],
      time: [
        data ? data.time : '',
        [ Validators.pattern(/^[1-9]\d*$/), Validators.required],
      ],
      responses: this.formBuilder.array(
        data && data.response_question?.length
          ? data.response_question?.map((item: { response_FR: string }) =>
              this.createFormResponse(item)
            )
          : [this.createFormResponse()]
      ),
    });
  }
  getstatevalue(event: any, i: number) {
    const newState = event.target.checked ? 1 : 0;
    this.responses.at(i)?.get('state')?.setValue(newState);
    this.responses.value.map(function (item: any) {
      if(item.state == null){
        item.state =0;
      }
      if(item.id == null){
        item.id ='';
      }
    });
  }
  isResponseDuplicate(index?: any): boolean {
    const currentResponse = this.normalizeSpaces(
      this.responses.controls[index]?.value?.response_FR
    ).trim();

    // Par défaut, aucune réponse n'est en double
    this.isDuplicateResponseErrorShown = false;

    for (let i = 0; i < this.responses.length; i++) {
      if (i !== index) {
        const previousResponse = this.normalizeSpaces(
          this.responses.controls[i]?.value?.response_FR
        ).trim();
        if (currentResponse === previousResponse) {
          // Si une réponse en double est trouvée, définissez isDuplicateResponseErrorShown sur true
          this.isDuplicateResponseErrorShown = true;
          return true;
        }
      }
    }

    // Aucune réponse en double n'a été trouvée
    return false;
  }

  normalizeSpaces(value: string): string {
    return value ? value.replace(/\s+/g, ' ').trim() : '';
  }
  hasDuplicateResponses(): boolean {
    for (let i = 0; i < this.responses.length - 1; i++) {
      if (this.isResponseDuplicate(i)) {
        return true;
      }
    }
    return false;
  }
  keyPressTextArea(event: any) {
    let textarea = event.target;

    // Gestion de la touche Entrée (Retour à la ligne)
    if (event.keyCode === 13) {
      event.preventDefault(); // Empêche le comportement par défaut de la touche "Entrée" (ajout de nouvelles lignes)
      let cursorPosition = textarea.selectionStart; // Obtient la position actuelle du curseur
      let textBeforeCursor = textarea.value.substring(0, cursorPosition);
      let textAfterCursor = textarea.value.substring(cursorPosition);
      textarea.value = textBeforeCursor + '\n' + textAfterCursor; // Ajoute un retour à la ligne à la position du curseur
      textarea.selectionStart = cursorPosition + 1; // Rétablit la position du curseur après l'ajout du retour à la ligne
      textarea.selectionEnd = cursorPosition + 1;
    }
    // Gestion de la touche Tabulation (Tab)
    else if (event.keyCode === 9) {
      event.preventDefault(); // Empêche le comportement par défaut de la touche "Tab" (changer de champ)
      let cursorPosition = textarea.selectionStart; // Obtient la position actuelle du curseur
      let textBeforeCursor = textarea.value.substring(0, cursorPosition);
      let textAfterCursor = textarea.value.substring(cursorPosition);
      textarea.value = textBeforeCursor + '\t' + textAfterCursor; // Ajoute une tabulation à la position du curseur
      textarea.selectionStart = cursorPosition + 1; // Rétablit la position du curseur après l'ajout de la tabulation
      textarea.selectionEnd = cursorPosition + 1;
    } else {
      let pattern = /^[a-zA-Z][a-zA-Z0-9]*$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }
  notOnlySpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value as string;
      const isValid = value?.trim() !== '';
      return isValid ? null : { onlySpaces: true };
    };
  }

  /* create response frm array */
  createFormResponse(data?: any) {
    return this.formBuilder.group({
      response_FR: [
        data?.response_FR ? data.response_FR : '',
        [Validators.required],
      ],
      state: [data?.state ? data.state : 0],
      id: [data?.id ? data.id : ''],
    });
    
  }

  /* get form array responses */
  get responses() {
    return this.questionForm.get('responses') as FormArray;
  }

  /* add new input response for diplome */
  addResponse() {
    this.responses.push(this.createFormResponse());
   
  }

  /* remove input response for diplome */
  removeResponse(index: number, res: any) {
    this.idResponse.push(res?.value?.id);
    this.responses.removeAt(index);
  }
  deleteResponse() {
    this.testService
      .deleteResponse(this.idResponse)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: () => {
          this.getQuestions();
        },
        error: (err) => {
          if (err?.error) {
            if (err.error?.message['question_FR']) {
              this.toastr.info(existedQuestion);
            } else if (err.error?.message['response_FR']) {
              this.toastr.info(existedQuestion);
            } else {
              this.toastr.error(serverError);
            }
          }
          this.spinner.hide();
        },
      });
  }

  confirmer() {
    if (this.mode == 'create_question') {
      this.addQuestion();
    } else {
      this.updateQuestion();
    }
  }
  /* Open and close modal */
  openModal(template: TemplateRef<any>, mode: string, data?: any, index?: number) {
    
   
    this.mode = mode;
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    if (this.mode == 'edit_question') {
      this.questionForm = this.createForm(data);
      this.state = data?.response_state
      this.questionForm.get('response_state')?.setValue(data?.response_state);
       this.selectedIndex = index;
    }
    else{
      this.questionForm.reset();
      this.responses.reset();
      this.state = 2
      this.questionForm.get('response_state')?.setValue('2');
    }
  }
  /* update question */
  updateQuestion() {
    if (this.idResponse.length) this.deleteResponse();
    this.questionForm.get('job_offer_id')?.setValue(this.jobId);
    if(this.state == 1){
      let valueArr = this.responses.value.map(function (item: any) {
        return item.response_FR.trim().toLowerCase();
      });
     
      let hasCorrectResponse = this.responses.controls.some(
        (
          control: AbstractControl<any, any>,
          index: number,
          array: AbstractControl<any, any>[]
        ) => {
          if (control instanceof FormGroup) {
            return control.get('state')?.value;
          }
          return false;
        }
      );

      if (!hasCorrectResponse ) {
        this.toastr.error(
          'Veuillez sélectionner au moins une réponse comme étant correcte.'
        );
        return;
      }
      this.responses.value.map(function (item: any) {
        if(item.state == null){
          item.state =0;
        }
      });
    }
    if(this.questionForm.value.idQuestion == null) {
       const index = this.selectedIndex; 
            if (index !== -1 && index != null) {
            this.creationTestPayload.questions[index] = {
              ...this.creationTestPayload.questions[index],
              question_FR: this.questionForm.value.question_FR,
              response_state: this.questionForm.value.response_state,
              time: this.questionForm.value.time?.toString(),
              response_question: this.state == 1 ? this.responses.value : [],
            };
          }
    }
    else {
          const index = this.creationTestPayload.questions.findIndex(
          (item) => item.id === this.questionForm.value.idQuestion
        );
        if (index !== -1) {
          this.creationTestPayload.questions[index] = {
            ...this.creationTestPayload.questions[index],
            question_FR: this.questionForm.value.question_FR,
            response_state: this.questionForm.value.response_state,
            time: this.questionForm.value.time?.toString(),
            response_question: this.state == 1 ? this.responses.value : [],
          };
        }
        }
    this.closeModal();
  }
  updateOpenForMission(value: number) {
    this.questionForm.get('response_state')?.setValue(value);
  }
  /* add question with response */
  addQuestion() {
    this.questionForm.get('job_offer_id')?.setValue(this.jobId);
    if(this.state == 1){
      let valueArr = this.responses.value.map(function (item: any) {
        return item.response_FR.trim().toLowerCase();
      });     
      let hasCorrectResponse = this.responses.controls.some(
        (
          control: AbstractControl<any, any>,
          index: number,
          array: AbstractControl<any, any>[]
        ) => {
          if (control instanceof FormGroup) {
            return control.get('state')?.value;
          }
          return false;
        }
      );

      if (!hasCorrectResponse ) {
        this.toastr.error(
          'Veuillez sélectionner au moins une réponse comme étant correcte.'
        );
        return;
      }
      this.responses.value.map(function (item: any) {
        if(item.state == null){
          item.state =0;
        }
      });
    }
      let data = {
        job_offer_id : this.questionForm.value.job_offer_id,
        question_FR: this.questionForm.value.question_FR,
        response_state: this.questionForm.value.response_state,
        time: this.questionForm.value.time?.toString(),
        responses : []
      }
      this.creationTestPayload.questions.push({
        id: null,
        question_FR: this.questionForm.value.question_FR,
        response_state: this.questionForm.value.response_state,
        time: this.questionForm.value.time?.toString(),
        response_question : this.state == 1? this.responses.value  : [],
        pUid: crypto.randomUUID() // adding a private uuid (id = null for new items)
      })
      this.closeModal();      
      if(this.state == 1){
        data.responses = this.responses.value     
      }    
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }


  closeModal() {
    this.modalRef!.hide();
    this.questionForm.reset();
    this.questionForm = this.createForm();
    this.idResponse = [];
    // this.state=0;
    const responsesArray = this.questionForm.get('responses') as FormArray;
    responsesArray.controls.forEach((control) => {
      control.get('state')?.setValue(false); // Réinitialiser l'état de chaque case à cocher
    });
  }
  addQuestionTest() {
      this.testService
        .createTestEsn(this.creationTestPayload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {            
            if (res.status == 200) {
              this.toastrService.success(successCreateTestEsn);
                {
                  this.router.navigate([
                    '/offres-emploi/liste-offres-emploi',
                    { jobId: this.jobId },
                  ]);
              }
            }
          },
          error: (err: any) => {
            if (
              err.error.message === 'test can not be created with one question.'
            ) {
              this.toastrService.error(
                'le test doit contenir au moins deux questions.'
              );
            }
          },
        });
  }

  sortType(e: any) {
    this.state = e.target.value;
   if( this.state == 1){
    this.responses.value.map(function (item: any) {
      if(item.state == null){
        item.state =0;
      }
    });
    this.questionForm.get('time')?.setValidators([Validators.required, Validators.pattern(/^[1-9]\d*$/)]);
  } else {
    // Remove the required validator if state is not 1
    this.questionForm.get('time')?.setValidators([Validators.pattern(/^[1-9]\d*$/)])
  
   }

  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  redirectTest(): void {
    this.router.navigate(['/offres-emploi/add-test-wegestu'], {
      queryParams: { jobId: this.jobId},
      state: {  testType: 'NO_TEST' },
    });
  }

  isTestQuestionsMinimal(questions: any[] | undefined) : boolean{
    return (questions?.length ?? 0) > 1;
  }

}
